/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSubscription } from '@apia/util';
import { CollectorField } from './CollectorField';
import { TValidationRules, TValidationFunction } from '../types';
import { validationsStore } from '../validationStore';

export abstract class ValidatedCollectorField<
  ValueType = any,
  FieldProps = any,
> extends CollectorField<ValueType, FieldProps> {
  constructor(
    public readonly name: string,
    protected label: string,
    protected config: Partial<{
      initialValue: ValueType;
      properties: Partial<FieldProps>;
      validationFunction: TValidationFunction<ValueType>;
      validationRules: TValidationRules;
    }> = {},
  ) {
    super(name, label, config?.properties);
  }

  get initialValue() {
    return this.config.initialValue;
  }

  get value() {
    return validationsStore.getFieldStore(this.collector.id, this.name).value;
  }

  setInitialValue = (newValue: ValueType) => {
    this.config.initialValue = newValue;
  };

  setValidationFunction = (newFunction: TValidationFunction<ValueType>) => {
    this.config.validationFunction = newFunction;
    this.emit('functionUpdate', this.config.validationFunction);
  };

  setValidationRules = (newRules: TValidationRules) => {
    this.config.validationRules = newRules;
    this.emit('rulesUpdate', { ...this.config.validationRules });
  };

  setValue = (newValue: ValueType) => {
    validationsStore.setFieldValue(this.collector.id, this.name, newValue);
  };

  protected useValidationFunction = () => {
    return useSubscription<TValidationFunction<ValueType> | undefined>({
      getInitialState: () => () => this.config.validationFunction,
      makeSubscription: (setValidationFunction) => {
        return this.on('functionUpdate', setValidationFunction);
      },
    });
  };

  protected useValidationRules = () => {
    return useSubscription({
      getInitialState: () => this.config.validationRules,
      makeSubscription: (setValidationRules) => {
        return this.on('rulesUpdate', setValidationRules);
      },
    });
  };
}
